// 9fbef606107a605d69c0edbcd8029e5d
const MAP_MIN_ZOOM_LEVEL = 3;
const MAP_NORMAL_STORE_LEVEL = 10;
const MAP_DEFAULT_ZOOM_LEVEL = 15;
const MAP_DEFAULT_LAT_LNG_US = { lat: 40.963784, long: -97.2160505 };
const MAP_DEFAULT_LAT_LNG_CA = { lat: 60.963784, long: -97.2160505 };
const DEFAULT_MAP_DIMENSION = 630;
const MAP_DIMENSION_ON_LOAD = {
  desktop: '932x600',
  mobile: '346x400',
};
const NEW_MAP_DIMENSION_ON_LOAD = {
  desktop: '932x350',
  mobile: '346x350',
};
const MAPBOX_STATIC_MAPS_URL = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static`;
const GOOGLE_STATIC_MAPS_URL = `https://maps.googleapis.com/maps/api/staticmap`;

export default {
  MAP_NORMAL_STORE_LEVEL,
  MAP_MIN_ZOOM_LEVEL,
  MAP_DEFAULT_ZOOM_LEVEL,
  MAP_DEFAULT_LAT_LNG_US,
  MAP_DEFAULT_LAT_LNG_CA,
  MAP_DIMENSION_ON_LOAD,
  NEW_MAP_DIMENSION_ON_LOAD,
  MAPBOX_STATIC_MAPS_URL,
  DEFAULT_MAP_DIMENSION,
  GOOGLE_STATIC_MAPS_URL,
};
